import React from "react";
import Autosuggest from "react-autosuggest";
import TagsInput from './tg-react-tagsinput';
import classnames from "classnames";
import { searchClientAddressBook } from "../actions/searchClientAddressBook";
import { CONTACT_TYPE, contactWith } from "../contactsModels";
import { validate as validateEmail } from "email-validator";
import { searchInputIn } from "../../common/searchTerms";
import LinkButton from "../../common/components/LinkButton";

export class ReceipientsSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: "",
            suggestions: []
        };

        this._handleSuggestionsUpdateRequested = this._handleSuggestionsUpdateRequested.bind(this);
        this._handleInputChange = this._handleInputChange.bind(this);
        this._handleInputKeyDown = this._handleInputKeyDown.bind(this);
        this._renderSuggestion = this._renderSuggestion.bind(this);
        this._handleSuggestionSelected = this._handleSuggestionSelected.bind(this);
        this._handlePaste = this._handlePaste.bind(this);
        this._handleBlur = this._handleBlur.bind(this);
        this._emitOnChange = this._emitOnChange.bind(this);
    }

    focus() {
        console.info("ReceipientsSearch::focus()")
    }

    render() {
        return (
            <Autosuggest suggestions={ this.state.suggestions }
                         onSuggestionsUpdateRequested={ this._handleSuggestionsUpdateRequested }
                         shouldRenderSuggestions={ value => value.emailAddress || (value.trim().length > 0) }
                         renderSuggestion={ this._renderSuggestion }
                         getSuggestionValue={ contact => contact.emailAddress }
                         onSuggestionSelected={ this._handleSuggestionSelected }
                         inputProps={{
                             value: this.state.inputValue,
                             onChange: this._handleInputChange,
                             onKeyDown: this._handleInputKeyDown,
                             onPaste: this._handlePaste,
                             onBlur: this._handleBlur,
                             autoCapitalize: "off",
                             autoComplete: "off",
                             autoCorrect: "off",
                             spellCheck: false,
                             placeholder: "Add email address(es)",
                             style: this.props.inputStyle,
                             className: "x-recipients-input react-autosuggest__input"
                         }}
            />
        );
    }

    _parseMultipleRecipients(contacts) {
        const split = (data) => data.split(/[;\n]/).map(d => d.trim());

        return split(contacts)
                   .filter(contact => contact.length > 0)
                   .map(contact => {
                       const contactWithName = contact.match(/([^ ]*) *([^<]*) <([^>]+)/);

                       if (contactWithName !== null) {
                           const [ entireMatch, firstName, lastName, emailAddress ] = contactWithName;
                           return contactWith({ emailAddress, firstName, lastName });
                       }

                       return contactWith({ emailAddress: contact })
                   });
    }

    _emitOnChange(data) {
        this.setState({ inputValue: "" });

        this.props.onChange(data);
    }

    _handlePaste(event) {
        event.preventDefault();

        const data = event.clipboardData.getData("Text");
        this._emitOnChange(this._parseMultipleRecipients(data));
    }

    _handleInputChange(event, {newValue, method}) {
        this.setState({ inputValue: newValue });
    }

    _handleInputKeyDown(event) {
        switch (event.key) {
            case "Enter":
                this._emitOnChange(this._parseMultipleRecipients(event.target.value));
                break;
            default:
        }
    }

    _handleBlur(event) {
        this._emitOnChange(this._parseMultipleRecipients(event.target.value));
    }

    _handleSuggestionSelected(event, {suggestion, method}) {
        this._emitOnChange([suggestion]);
    }

    _handleSuggestionsUpdateRequested({value, reason}) {
        switch (reason) {
            case "type":
                searchClientAddressBook(value, results => {
                    this.setState({
                        suggestions: results
                    });
                });
                return;
            default:
                return;
        }
    }

    _renderSuggestion(contact, { value: searchTerm }) {
        const email = searchInputIn(contact.emailAddress, searchTerm);

        return (
            <span className="x-instrument-search-result">
                {email.beforeMatch}<strong>{email.match}</strong>{email.afterMatch} <br/>
            </span>
        );
    }

}
ReceipientsSearch.propTypes = {
    onChange: React.PropTypes.func,
    value: React.PropTypes.shape({
        emailAddress: React.PropTypes.string
    })
};

class Recipients extends React.Component {
    render() {
        return (
            <div className={ classnames(this.props.className) }
                 style={ this.props.style } >
                <TagsInput ref="tagsinput"
                           value={ this.props.value }
                           onChange={ this.props.onChange }
                           renderInput= { () =>
                               <ReceipientsSearch ref="input"
                                                  onChange={ contact => this.props.onChange(this.props.value.concat(contact)) }
                                                  inputStyle={this.props.inputStyle} />
                           }
                           renderLayout={(tagComponents, inputComponent) => (
                                <div>
                                    <div style={{maxHeight: 200, overflowY: "auto", overflowX: "hidden", marginBottom: 5}}>
                                        {tagComponents}
                                    </div>
                                    {this.props.value.length > 2 ?
                                        <div style={{textAlign: "right"}}>
                                            <LinkButton
                                                className="x-remove-all-tags"
                                                style={{padding: "5px 0 10px 0"}}
                                                onClick={() => this.props.onChange([])}>
                                                Remove All
                                            </LinkButton>
                                        </div>
                                        : null
                                    }
                                    <div>
                                        {inputComponent}
                                    </div>
                                </div>
                           )}
                           getTagValue={tag => tag.emailAddress}
                           renderTag={ renderTag }
                />
            </div>
        );
    }
}
Recipients.propTypes = {
    onChange: React.PropTypes.func,
    className: React.PropTypes.string,
    style: React.PropTypes.object,
    value: React.PropTypes.array
};
Recipients.defaultProps = {
    value: []
};


function renderTag(props) {
    const {tag, key, onRemove, className, ...other} = props;
    const invalidEmailStyle = {
        backgroundColor: "rgba(231,0,0,0.84)"
    };

    let style = {}, content;

    if (tag.type === CONTACT_TYPE.ADDRESS) {
        style = validateEmail(tag.emailAddress) ? {} : invalidEmailStyle;
        content = tag.emailAddress;
    } else {
        style = { fontWeight: "bold" };
        content = `${tag.name} (${tag.contacts.length})`;
    }

    return (
        <span key={key}
              className={classnames("x-tag", className)}
              style={ style }
              {...other} >
            { content }
            <a onClick={(e) => onRemove(key)} className="x-remove-tag"/>
        </span>
    );
}

export default Recipients;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/contacts/components/Recipients.js
 **/